import createHistory from "history/createBrowserHistory";
import qs from 'qs';

export const HISTORY = createHistory();

export const getQueryParamValue = (paramName) => {
  let parsed = qs.parse(HISTORY.location.search, {ignoreQueryPrefix: true});
  return parsed[paramName];
}

export const updateQueryString = (qString, params) => {
  if (params && params.length > 0) {
    let parsed = qs.parse(qString, {ignoreQueryPrefix: true});

    for (let i = 0; i < params.length; i++) {

      let param = params[i].name;
      let value = params[i].value;

      if (!value) {
        delete parsed[param];
      }
      else {
        parsed[param] = value;
      }

    }
    return qs.stringify(parsed);
  }

  return "";
}

export const makeParam = (paramName, paramValue) => ({name: paramName, value: paramValue});